// extracted by mini-css-extract-plugin
module.exports = {"invoice":"_10439","image":"_8468","actions":"_17205","button":"_13770","gray":"_5990","placeholder":"_11117"};